import { render, staticRenderFns } from "./TeacherReview.vue?vue&type=template&id=4495636e"
import script from "./TeacherReview.vue?vue&type=script&lang=js"
export * from "./TeacherReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports